import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import { URL_SERVICIOS_LOCALES } from '../config/url.servicio'
import { URL_SERVICIOS_AWS } from '../config/url.servicio'
import { NUBE_AWS } from '../config/url.servicio'
import { Store } from '@ngrx/store';
import { AppState } from './../app/app.reducer';
import { UnsetTurnosAction } from '../pages/meseromesero/state/turnos/turnos.accions';
import { UnsetTurnosAsignadosAction } from '../pages/meseromesero/state/turnos-asignados/turnos-asignados-accions';
import { UnsetParametrosgeneralesAction } from '../pages/parametros-generales/state/parametrosgenerales/parametrosgenerales.accions';
import { UnsetRutasAction } from '../state/rut.accions';
import { UnSetProductsAction } from '../pages/meseromesero/state/productos/productos.actions';
import { UnsetGestionpedidosAction } from '../pages/meseromesero/state/gestionpedidos/gestionpedidos.accions';
import { UnsetEstadosAction } from '../pages/meseromesero/state/estados/estados.accions';
import { UnsetClienteselectAction } from '../pages/meseromesero/state/clienteselect/clienteselect.accions';

@Injectable()
export class AuthService {

  private isLoggedIn = false;

  constructor(
    private http: Http,
    private storage: Storage,
    private store: Store<AppState>,
  ) { }

  /**
   * @method login este metodo se encarga de autenticar y retornar las agencias y el token
   * @param credenciales parametros clave y usuarios para autenticar
   */
  login(credenciales) {
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option

    let url = !NUBE_AWS ? URL_SERVICIOS_LOCALES : URL_SERVICIOS_AWS

    return this.http.post(`${url}/login`, credenciales, options)
     .map((data)=> data.json())
  }

  /**
   * @method setVarsSession se encarga se hacer set en el session storage de todas las variables de session
   * @param obj objecto con todas las variables de session
   */
  setVarsSession(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const element = obj[key];
        this.storage.set(key, element)
      }
    }
    this.isLoggedIn = true
  }

  // verificar si esta autenticado
  authenticated() {
    return this.storage.get('token').then((val) => {
      if(val) {
        this.isLoggedIn = true
      } else {
        this.isLoggedIn = false

      }

      return this.isLoggedIn
    });
  }

  /**
   * @method logout este metodo se encarga de limpiar todas las varibles de session
   */
  logout() {
    this.store.dispatch(new UnsetTurnosAction());
    this.store.dispatch(new UnsetTurnosAsignadosAction());
    this.store.dispatch(new UnsetParametrosgeneralesAction());
    this.store.dispatch(new UnsetRutasAction());
    this.store.dispatch(new UnSetProductsAction());
    this.store.dispatch(new UnsetGestionpedidosAction());
    this.store.dispatch(new UnsetEstadosAction());
    this.store.dispatch(new UnsetClienteselectAction());
    this.storage.remove('companiasId')
    this.storage.remove('token')
    console.log('Se limpian las variables cargadas en redux')
  }

  /**
   * @method extractData extraer la respuesta y formatearla a json
   * @param res
   */
  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }


  /**
   * @method handleError manejo de errores en la peticion
   * @param error
   */
  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
        const body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
        errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts